import { useEffect, useState } from 'react';
import Chart from 'react-google-charts';

const BarChart = (props: any) => {
  const options = { legend: {position: 'none', alignment: 'center'}, colors: ["purple"], tooltip: { trigger: "none" } };
  const [orderData, setOrderData] = useState([]);
  useEffect(() => {
    let orderData: any = [["Month", "Units", {role: "annotation"}]];
    for(let i = 0; i < props.data.length; ++i) {
      let data: any = [props.data[i][0], +props.data[i][1], props.data[i][2]];
      orderData.push(data);
    }
    setOrderData(orderData);
  }, []);

  return (
    <div style={{ fontFamily: 'sans-serif !important'}}>
      <Chart chartType="ColumnChart" height={"300px"} width="1000px" data={orderData} options={options}/>
    </div>
  );
}

export default BarChart;